import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ExampleNetworkStatus = 'idle' | 'loading' | 'failed'

export interface ExampleReduxState {
    value: number
    status: ExampleNetworkStatus
}

const initialState: ExampleReduxState = {
    value: 0,
    status: 'idle',
}

export const exampleSlice = createSlice({
    name: 'example',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        increment: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.value += 1
        },
        decrement: (state) => {
            state.value -= 1
        },
        // Use the PayloadAction type to declare the contents of `action.payload`
        incrementByAmount: (state, action: PayloadAction<number>) => {
            state.value += action.payload
        },
        setStatus: (state, action: PayloadAction<ExampleNetworkStatus>) => {
            state.status = action.payload
        },
    },
})

export default exampleSlice
